import React, { useEffect, useState } from "react";
import { Modal, Button, Select, Spin, Empty } from "antd";
import { Society } from "common/interface/Society";

interface AddSocietiesModalProps {
  open: boolean;
  status: string;
  societyOptions: Society[];
  isLoadingOptions: boolean;
  alreadyMappedIds: number[];
  onSearch: (query: string) => void;
  onCancel: () => void;
  onConfirm: (societyIds: number[]) => void;
}

export const AddSocietiesModal: React.FC<AddSocietiesModalProps> = ({
  open,
  status,
  societyOptions,
  isLoadingOptions,
  alreadyMappedIds,
  onSearch,
  onCancel,
  onConfirm,
}) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  useEffect(() => {
    if (open) {
      setSelectedIds([]);
    }
  }, [open]);

  const handleOk = () => {
    onConfirm(selectedIds);
  };

  return (
    <Modal
      title="Add Societies to Drop Point"
      open={open}
      onCancel={onCancel}
      width={480}
      centered
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <Button onClick={onCancel} disabled={status === "saving"}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleOk}
            loading={status === "saving"}
            disabled={selectedIds.length === 0}
          >
            Add
          </Button>
        </div>
      }
    >
      <Select
        mode="multiple"
        showSearch
        allowClear
        style={{ width: "100%" }}
        placeholder="Search societies by name"
        value={selectedIds}
        onChange={setSelectedIds}
        onSearch={onSearch}
        filterOption={false}
        loading={isLoadingOptions}
        notFoundContent={isLoadingOptions ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
        optionLabelProp="label"
      >
        {societyOptions
          .filter((society) => !alreadyMappedIds.includes(Number(society.id)))
          .map((society) => (
            <Select.Option value={Number(society.id)} label={society.name} key={society.id}>
              {society.name} || {society.id}
            </Select.Option>
          ))}
      </Select>
    </Modal>
  );
};
